// This file is generated by a script and should not be modified directly.
const markdown: string =
  "**Liste des couples CFD-RNCP assurant la continuité de la certification professionnelle.** La liste inclut à la fois les fiches remplacées et remplaçantes. Elle est ordonnée par date d'activation de la fiche RNCP et inclut la fiche courante.\n"
export default markdown
